import { ImpedimentReason, impedimentReasonLabels } from '@/enums/generic';

export const allgemeineNutzung = 'Allgemeine Nutzung';

export const usageTypeList = Object.freeze([
  { name: 'Nutzeinheit', value: 'LIVING', icon: 'sofa' },
  { name: 'Gewerbeeinheit', value: 'BUSINESS', icon: 'briefcase' },
  { name: 'Allgemeine Nutzung', value: 'GENERAL', icon: 'home-roof' },
]);

export enum roomGroupUsageTypes {
  LIVING = 'LIVING',
  BUSINESS = 'BUSINESS',
  GENERAL = 'GENERAL',
}

export const roomgroupNotAccessibleReasonsList = Object.freeze([
  ImpedimentReason.NOT_ENCOUNTERED_NAME_CORRECT,
  ImpedimentReason.NO_RESPONSE_DESPITE_RINGING,
  ImpedimentReason.USER_REFUSES_ACCESS_CURRENTLY,
  ImpedimentReason.CONTACT_PERSON_UNREACHABLE,
  ImpedimentReason.INSTALLATION_REFUSED,
  ImpedimentReason.SPECIAL_CONSIDERATIONS,
  ImpedimentReason.NEW_APPOINTMENT_NEEDED,
  ImpedimentReason.ACCESS_REFUSED_BY_TECHNICIAN,
  ImpedimentReason.USER_REFUSES_ACCESS_PERMANENTLY,
  ImpedimentReason.UNIT_NOT_FOUND,
  ImpedimentReason.UNREASONABLE,
  ImpedimentReason.OTHER,
].map((value) => ({ name: impedimentReasonLabels[value], value })));

export const AVERAGE_SRT_PER_ROOM_GROUP = 4.85;
